import { combineReducers } from 'redux'
import APIRequest from '../helpers/APIRequest'

export const RECEIVE_STRUCTURES = 'RECEIVE_STRUCTURES'
export const RECEIVE_STRUCTURE = 'RECEIVE_STRUCTURE'
/*
const xrd = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_XRD:
      return {
        // action.xrd,
      }
    default:state
      return state
}

const structureReducer = combineReducers({
  structure,
  xrd
})
*/
const byId = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_STRUCTURES:
      return {
        ...state,
        ...action.structures.reduce((obj, structure) => {
          obj[structure._id] = structure
          return obj
        }, {})
      }
    case RECEIVE_STRUCTURE:
      return {
        ...state,
        [action.structure._id]: action.structure
      }
    default:
      return state
  }
}

const visibleIds = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_STRUCTURES:
      return action.structures.map(structure => structure._id)
    case RECEIVE_STRUCTURE:
      return [...state, action.structure._id]
    default:
      return state
  }
}

export default combineReducers({
  byId,
  visibleIds
})

export const getStructure = (state, id) =>
  state.byId[id]

export const getVisibleStructures = state =>
  state.visibleIds.map(id => getStructure(state, id))



export const receiveStructures = structures => ({
  type: RECEIVE_STRUCTURES,
  structures: structures
})

export const receiveStructure = structure => ({
  type: RECEIVE_STRUCTURE,
  structure: structure
})

export const getAllStructures = () => dispatch => {
  APIRequest.get('structures').then(res => {
    dispatch(receiveStructures(res.data));
  })
}

export const getStructureById = (id) => dispatch => {
  APIRequest.get(`structures/${id}`).then(res => {
    dispatch(receiveStructure(res.data));
  })
}



// WEBPACK FOOTER //
// ./src/modules/structures.js